export const formatPrice = (price: number): string => (price / 100).toFixed(2);
